// ==========================================================================
// CACTUS KNIGHT — kleine localStorage-Helfer mit In-Memory-Fallback
// Früher Teil von js/cart.js. Der Warenkorb selbst läuft jetzt nativ über
// Shopify (kein localStorage mehr nötig) — lang.js und cookie-consent.js
// brauchen aber weiterhin einen simplen, robusten Key-Value-Speicher.
// ==========================================================================

const _ckMemoryStore = {};

function ckStorageGet(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    return _ckMemoryStore[key] ?? null;
  }
}

function ckStorageSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (e) {
    _ckMemoryStore[key] = value;
  }
}

function ckStorageRemove(key) {
  try {
    window.localStorage.removeItem(key);
  } catch (e) {
    delete _ckMemoryStore[key];
  }
}
